// extracted by mini-css-extract-plugin
export default {"container":"banner_container__2Cm58","opened":"banner_opened__18BPx","bottom":"banner_bottom__LqPcb","draw-path":"banner_draw-path__2MAr2"};